<template>
  <v-wait :visible="loading" :for="$options.name">
    <template slot="waiting">
      <HalfCircleSpinner />
      <div class="spinner-message my-3 text-center">
        Loading data...
      </div>
    </template>
    <component
      v-if="componentData && jobQuestion"
      ref="inputComponent"
      :is="componentData.name"
      :key="jobQuestion.id"
      v-bind="componentData.props"
      @save-details="$emit('save-details', $event)"
      @save-specialty="$emit('save-specialty', $event)"
      @set-criteria-value="$emit('set-criteria-value', $event)"
      @clear-criteria-value="$emit('clear-criteria-value', $event)"
      @set-job-terms="$emit('set-job-terms', $event)"
      @set-profile-job-terms="$emit('set-profile-job-terms', $event)"
      @show-next-btn="$emit('show-next-btn', $event)"
      @updatePropValue="$emit('updatePropValue', $event)"
      @isJobInfoActive="$emit('isJobInfoActive', $event)"
    />
  </v-wait>
</template>

<script>
import RecruiterIcoDetailLocation from '@/components/recruiter/ico/criteria/detail/RecruiterIcoDetailLocation';
import JobInformationInput from '@/components/recruiter/exchange/create-job-offer/job-offer-input/JobInformationInput';
import SpecialtyInput from '@/components/recruiter/exchange/create-job-offer/job-offer-input/SpecialtyInput';
import { JOB_QUESTION_TYPES } from '@/store';
import { HalfCircleSpinner } from 'epic-spinners';
import RecruiterIcoDetailJobQuestion from '@/components/recruiter/ico/criteria/detail/RecruiterIcoDetailJobQuestion';

export default {
  name: 'JobOfferInput',
  components: {
    JobInformationInput,
    RecruiterIcoDetailLocation,
    SpecialtyInput,
    HalfCircleSpinner,
    RecruiterIcoDetailJobQuestion,
  },
  props: {
    jobQuestion: Object,
    jobOffer: Object,
    loading: Boolean,
    jobId:Number
  },
  computed: {
    componentData: function () {
      const talentType = (this.jobQuestion || {}).talent_type;
      this.getLocation(talentType);
      switch (talentType) {
        case JOB_QUESTION_TYPES.LOCATION:
          return {
            name: RecruiterIcoDetailLocation.name,
            props: {
              jobQuestion: this.jobQuestion,
              jobOffer: this.jobOffer,
              loadingDetail: this.loadingDetail,
            },
          };
        case JOB_QUESTION_TYPES.JOB_INFORMATION:
          return {
            name: JobInformationInput.name,
            props: {
              jobOffer: this.jobOffer,
              actionName: 'save-details',
            },
          };
          case JOB_QUESTION_TYPES.SPECIALTY:
            return {
              name: SpecialtyInput.name,
              props: {
                actionName: 'save-specialty',
                jobOffer: this.jobOffer,
                initialSpecialtyId: this.jobOffer
                  ? (this.$store.state.job_offer && this.$store.state.job_offer.length > 0) ? this.$store.state.job_offer[0].value.specialtyId : this.jobOffer.specialty_id
                : null,
                initialSubspecialtyId: this.jobOffer ? (this.$store.state.job_offer && this.$store.state.job_offer.length > 0) ? this.$store.state.job_offer[0].value.subspecialtyId : this.jobOffer.subspecialty_id
                : null,
              },
            };
        case JOB_QUESTION_TYPES.BOARD_CERTIFICATION:
          return {
            name: RecruiterIcoDetailJobQuestion.name,
            props: {
              actionName: 'set-job-terms',
              jobQuestion: this.jobQuestion,
              loadingDetail: this.loadingDetail,
            },
          };
        case JOB_QUESTION_TYPES.VISA_STATUS:
        case JOB_QUESTION_TYPES.ETHNICITY:
        case JOB_QUESTION_TYPES.GENDER:
          return {
            name: RecruiterIcoDetailJobQuestion.name,
            props: {
              actionName: 'set-profile-job-terms',
              jobQuestion: this.jobQuestion,
              loadingDetail: this.loadingDetail,
            },
          };
        default:
          return {
            name: RecruiterIcoDetailJobQuestion.name,
            props: {
              jobQuestion: this.jobQuestion,
              loadingDetail: this.loadingDetail,
            },
          };
      }
    },
  },
  methods: {
    getLocation : function(talent_type){
      if(talent_type == JOB_QUESTION_TYPES.LOCATION)
      {
        this.jobQuestion.value = this.jobOffer.location_zip_code;
      }
    },
    isDirty: function () {
      if (!this.$refs.inputComponent) return false;
      return (
        typeof this.$refs.inputComponent.isDirty === 'function' &&
        this.$refs.inputComponent.isDirty()
      );
    },
    isValid: function () {
      if (!this.$refs.inputComponent) return true;
      return this.$refs.inputComponent.isValid();
    },
    resetValidation: function () {
      return (
        this.$refs.inputComponent &&
        typeof this.$refs.inputComponent.resetValidation === 'function' &&
        this.$refs.inputComponent.resetValidation()
      );
    },
  },
};
</script>

<style scoped></style>
